const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8080';
  }
  // care.{instance}.ospitek.com → api.{instance}.ospitek.com
  // care.ospitek.com → api.view.ospitek.com (alias for view instance)
  if (hostname.endsWith('.ospitek.com')) {
    const sub = hostname.replace('.ospitek.com', '');
    const instance = sub.startsWith('care.') ? sub.slice(5) : sub;
    if (!instance || instance === 'care') {
      return 'https://api.view.ospitek.com';
    }
    return `https://api.${instance}.ospitek.com`;
  }
  console.warn(`[config] Unknown hostname: ${hostname}, falling back to localhost`);
  return 'http://localhost:8080';
};

const getAppUrl = () => {
  if (process.env.REACT_APP_URL) return process.env.REACT_APP_URL;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:3000';
  if (hostname.endsWith('.ospitek.com')) {
    const sub = hostname.replace('.ospitek.com', '');
    const instance = sub.startsWith('care.') ? sub.slice(5) : sub;
    if (!instance || instance === 'care') return 'https://view.ospitek.com';
    return `https://${instance}.ospitek.com`;
  }
  return window.location.origin;
};

const config = {
  nodeEnv: process.env.NODE_ENV,
  publicURL: window.location.origin,
  apiURL: getApiUrl(),
  appURL: getAppUrl(),
  careURL: window.location.origin,
};

export default config;
